import { render, staticRenderFns } from "./FullPageLoader.vue?vue&type=template&id=038b6c01"
import script from "./FullPageLoader.vue?vue&type=script&lang=js"
export * from "./FullPageLoader.vue?vue&type=script&lang=js"
import style0 from "./FullPageLoader.vue?vue&type=style&index=0&id=038b6c01&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports